import { queryClient } from '@/fetching/queryClient';
import { PERSISTENT_LOCAL_STORAGE_KEYS } from '@/utils/browserStorage';
import { useCallback } from 'react';

export const useClearLocalData = () => {
    return useCallback(() => {
        const persistentData = new Map<string, string>();
        PERSISTENT_LOCAL_STORAGE_KEYS.forEach((key) => {
            const value = localStorage.getItem(key);
            if (value !== null) {
                persistentData.set(key, value);
            }
        });

        localStorage.clear();
        sessionStorage.clear();

        queryClient.clear();

        persistentData.forEach((value, key) => {
            localStorage.setItem(key, value);
        });
    }, []);
};

export const softResetLocalData = (route: string, uuid?: string) => {
    return queryClient.invalidateQueries(uuid ? [route, uuid] : [route]);
};
